// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"544":"f5c339a70e7b1465c609","909":"a72e75cf95e0f2f41795"}[chunkId] + ".css";
};